/**
 * TanStack Query key for the deals cart
 */
export const DEALS_CART_QUERY_KEY = ["deals-cart"] as const;

/**
 * Cache configuration for deals cart queries
 */
export const DEALS_CART_CACHE_CONFIG = {
  staleTime: 30 * 1000, // 30 seconds
  gcTime: 5 * 60 * 1000, // 5 minutes
  refetchOnWindowFocus: true,
} as const;
